import tw from 'tailwind-styled-components'

export const DateTimeNotification  = tw.div`
text-sm
font-medium
not-italic
text-left
`
